import * as React from 'react'
import { connect, Dispatch } from 'react-redux'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'
import { AppBarContainer } from './CustomAppBar'
import '../styles/WaitingForAuthorization.scss'
import { Api } from '../services/api/api'
import { JobStatus } from '../types/enums/JobStatus'
import { RouterAction, routerActions } from 'react-router-redux'
import { ROUTES } from '../constants/routes'
import { StoreState } from '../reducers'
import { Actions as JobActions, ActionType as JobActionType } from '../actions/job'
import { removeJobDetails, setProviderId, setFutureDateFrom, setFutureDateTo } from '../actions/setJobDetails'
import ErrorDialog from '../components/ErrorDialog'
import { Job } from '../types'
import { InfoDialog } from '../components/InfoDialog'

interface WaitingForAuthorizationProps {
  jobId: string,
  haulerId: string
  amount: number

  routePush: (path: String) => RouterAction
  onRemoveJobDetails: () => void,
  removeJob: () => JobActionType,
  setProviderId: (providerId: string) => void
  onSetFutureDateFrom: (futureDateFrom: number) => void
  onSetFutureDateTo: (futureDateTo: number) => void
}

interface WaitingForAuthorizationStates {
  status: string
  isErrorDialogOpen: boolean
  isInfoDialogOpen: boolean
  errorTitle: string,
  errorMessage: string
}

export class WaitingForAuthorization extends React.Component<WaitingForAuthorizationProps, WaitingForAuthorizationStates> {
  constructor(props: any) {
    super(props)
    this.state = {
      status: '',
      isErrorDialogOpen: false,
      isInfoDialogOpen: false,
      errorTitle: '',
      errorMessage: ''
    }
  }

  componentDidMount() {
    Api.getJob(this.props.jobId)
      .then((result: Job) => {
        if (result.jobCategory && !result.jobCategory.countable) {
          Api.acceptBid(this.props.jobId, this.props.haulerId)
            .then((result) => {
              this.checkJobStatus()
            })
            .catch(error => {
              console.log('can not accept bid', error)
              this.setState({
                isErrorDialogOpen: true,
                errorTitle: StringResources.getString(Strings.JobDetails.Errors.Titles.jobCancelled),
                errorMessage: StringResources.getString(Strings.JobDetails.Errors.Messages.CannotAuthorizeCard)
              })
            })
        } else this.checkJobStatus()
      })
  }

  componentDidUpdate() {
    if (this.state.errorTitle === '') {
      this.checkJobStatus()
    }
  }

  checkJobStatus = () => {
    Api.getJob(this.props.jobId)
      .then((result: any) => {
        this.setState({
          status: result.status
        })
        if (result.status === JobStatus.ACCEPTED) {
          this.props.onSetFutureDateFrom(result.futureDateFrom)
          this.props.onSetFutureDateTo(result.futureDateTo)
          this.setState({
            isInfoDialogOpen: true
          })
        } else if (result.status === JobStatus.PAYMENT_ERROR || result.status === JobStatus.DECLINED_BY_CUSTOMER ||
          result.status === JobStatus.CANCELLED_BY_CUSTOMER) {
          this.setState({
            isErrorDialogOpen: true,
            errorTitle: StringResources.getString(Strings.JobDetails.Errors.Titles.jobCancelled),
            errorMessage: StringResources.getString(Strings.JobDetails.Errors.Messages.CannotAuthorizeCard)
          })
        }
      })
      .catch(error => {
        console.log('Can not load job status.', error)
      })
  }

  handleInfoDialogClose = () => {
    this.setState({
      isInfoDialogOpen: false
    })
    this.props.routePush(ROUTES.BID_ACCEPTED)
  }

  handleErrorDialogClose = (e: any) => {
    this.props.onRemoveJobDetails()
    this.props.removeJob()
    this.setState({
      isErrorDialogOpen: false
    })
    if (e.currentTarget.name === this.state.errorTitle) {
      this.props.routePush(ROUTES.PICKUP_LOCATION)
    }
  }

  render() {
    return (
      <div className="wait-for-auth-form">
        <AppBarContainer
          isIconButtonsShown={true}
          isMenuShown={true}
        />
        <InfoDialog
          isInfoDialogOpen={this.state.isInfoDialogOpen}
          handleInfoDialogClose={this.handleInfoDialogClose}
          amount={this.props.amount}
        />
        <ErrorDialog
          handleErrorDialogClose={this.handleErrorDialogClose}
          isErrorDialogOpen={this.state.isErrorDialogOpen}
          errorTitle={this.state.errorTitle}
          errorMessage={this.state.errorMessage}
        />
        {StringResources.getString(Strings.WaitingForAuthorization.Message)}
      </div>
    )
  }
}
function mapStateToProps(state: StoreState) {
  return {
    jobId: state.jobDetails.jobId,
    haulerId: state.jobDetails.providerId,
    amount: state.jobDetails.amount
  }
}
function mapDispatchToProps(dispatch: Dispatch<any>) {
  return {
    routePush: (location: string) => dispatch(routerActions.push(location)),
    onRemoveJobDetails: () => dispatch(removeJobDetails()),
    removeJob: () => dispatch(JobActions.createJob(null)),
    onSetFutureDateFrom: (futureDateFrom: number) => dispatch(setFutureDateFrom(futureDateFrom)),
    onSetFutureDateTo: (futureDateTo: number) => dispatch(setFutureDateTo(futureDateTo)),
    setProviderId: (providerId: string) => dispatch(setProviderId(providerId))
  }
}
export const WaitingForAuthorizationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(WaitingForAuthorization)



// WEBPACK FOOTER //
// ./src/containers/WaitingForAuthorization.tsx